/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Room area
 * @export
 * @interface TravelineRoomTypeSquareDto
 */
export interface TravelineRoomTypeSquareDto {
    /**
     * Area, value in square meters
     * @type {number}
     * @memberof TravelineRoomTypeSquareDto
     */
    value: number;
}

/**
 * Check if a given object implements the TravelineRoomTypeSquareDto interface.
 */
export function instanceOfTravelineRoomTypeSquareDto(value: object): value is TravelineRoomTypeSquareDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function TravelineRoomTypeSquareDtoFromJSON(json: any): TravelineRoomTypeSquareDto {
    return TravelineRoomTypeSquareDtoFromJSONTyped(json, false);
}

export function TravelineRoomTypeSquareDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRoomTypeSquareDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

  export function TravelineRoomTypeSquareDtoToJSON(json: any): TravelineRoomTypeSquareDto {
      return TravelineRoomTypeSquareDtoToJSONTyped(json, false);
  }

  export function TravelineRoomTypeSquareDtoToJSONTyped(value?: TravelineRoomTypeSquareDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

